<template>
  <q-page>
    <div class="q-ma-md render-container" v-html="renderedMd"></div>
  </q-page>
</template>

<script>
import { updateCustomMd } from '../../js/customMdParse/customMdParse'

export default {
  name: 'home',
  data () {
    return {
      content: `# Submind
Submind is a note taking app designed for coders and those who like to experiment with, rapidly
build, and test tools that help organise their work.

Submind was built to solve some of the frustrations of other note taking apps that were built
to please everyone.  Instead of being generalised, Submind focuses on the technical user.

### Key Features:
- [write notes in markdown](https://github.com/markedjs/marked)
- <a href="/docs/components" onclick="event.preventDefault(); $ch.router.push('/docs/components')">components</a>
- <a href="/docs/note-templates" onclick="event.preventDefault(); $ch.router.push('/docs/note-templates')">note templates</a>
- <a href="/docs/public-notes" onclick="event.preventDefault(); $ch.router.push('/docs/public-notes')">publish and share notes</a>
- works offline/online
- fast
- desktop and mobile support

`,
      renderedMd: '',
      componentDefinitionAry: []
    }
  },
  mounted () {
    this.renderedMd = updateCustomMd(this.content || '', this.componentDefinitionAry, this.item, null, false, this.saveThrottled) // eslint-disable-line vue/no-side-effects-in-computed-properties
    this.renderedMd = this.renderedMd + '<div style="width: 100%; height: 25vh;"></div>' // eslint-disable-line vue/no-side-effects-in-computed-properties
    // updateComponentHtmlInDOM()
  }
}
</script>

<style scoped>

</style>
